import { useEffect } from "react";
import { useExplore } from "@/lib/ExploreContext";
import { useSaved } from "@/lib/SavedContext";
import { readPlaces, rememberPlaces } from "@/lib/visitorProfile";

/**
 * Keeps a slim copy of the visitor's saved places on their device, so My List
 * still opens with no signal. Renders nothing. A place the directory has not
 * loaded yet keeps its last copy rather than being dropped.
 */
export default function SavedSnapshot() {
  const { allListings, beaches, viatorListings, badBunnyListings, nbNames } = useExplore();
  const { saved } = useSaved();

  useEffect(() => {
    const timer = window.setTimeout(() => {
      if (!saved.size) {
        rememberPlaces([]);
        return;
      }
      const catalog = [...allListings, ...beaches, ...viatorListings, ...badBunnyListings].filter((item) => item?.id);
      // Nothing loaded yet (or offline): leave the stored copy as it is.
      if (!catalog.length) return;

      const found = Array.from(new Map(catalog.filter((item) => saved.has(item.id)).map((item) => [String(item.id), item])).values())
        .map((item) => ({ ...item, destination: item.destination || nbNames?.[item.neighborhood_id] || "" }));
      const foundIds = new Set(found.map((item) => String(item.id)));
      const kept = readPlaces().filter((item) => saved.has(item.id) && !foundIds.has(String(item.id)));
      rememberPlaces([...found, ...kept]);
    }, 600);
    return () => window.clearTimeout(timer);
  }, [saved, allListings, beaches, viatorListings, badBunnyListings, nbNames]);

  return null;
}
